<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
            <h1 class="title-default">Emissor</h1>
            <p class="welcome-message">
                <button mat-icon-button type="button" (click)="cancelar()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                Gerenciamento de emissores de documentos fiscais
            </p>

            <div class="section-container">
                <div class="section-title">
                    <mat-icon class="material-symbols-outlined">badge</mat-icon>
                    <span>Dados básicos</span>
                </div>

                <div class="row g-3">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Nome</mat-label>
                            <input matInput formControlName="nome" type="text" placeholder="Ex: Checkout 001" maxlength="30">
                            @if (model.get('nome')?.invalid) {
                            <mat-error>Informe o nome do emissor</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="col-md-3">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Tipo ambiente</mat-label>
                            <mat-select formControlName="opcaoAmbiente">
                                <mat-option [value]="OpcaoAmbienteEmissorEnum.Automatico">{{ descricaoOpcaoAutomatico }}</mat-option>
                                <mat-option [value]="OpcaoAmbienteEmissorEnum.Homologacao">Homologação</mat-option>
                                <mat-option [value]="OpcaoAmbienteEmissorEnum.Producao">Produção</mat-option>
                            </mat-select>
                            @if (isAutomaticoSelecionado) {
                            <mat-hint>Automático: o emissor acompanha o ambiente definido nas configurações gerais do sistema.</mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-3 field-height-actions">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="ativo">Ativo</mat-slide-toggle>
                    </div>

                    <div class="col-md-12">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Descrição</mat-label>
                            <input matInput formControlName="descricao" type="text"
                                placeholder="Ex: Checkout proximo a porta" maxlength="60">
                        </mat-form-field>
                    </div>

                    @if (idEmissor) {
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Token</mat-label>
                            <input matInput formControlName="token" type="text" readonly>

                            <button mat-icon-button matSuffix type="button" (click)="copyToken()"
                                [disabled]="!model.get('token')?.value" matTooltip="Copiar token">
                                <mat-icon>content_copy</mat-icon>
                            </button>

                            <button mat-icon-button matSuffix type="button" (click)="modalConfirmChangeToken()"
                                matTooltip="Regerar token">
                                <mat-icon>autorenew</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    }
                </div>

                @if (exibirAvisoNFCeAutomatico) {
                <app-alert-card class="d-block mt-3" type="info">
                    A NFC-e deste emissor também passará a acompanhar o ambiente da configuração geral.
                </app-alert-card>
                }
            </div>

            <app-ativacao-section-card
                [control]="$any(model.get('emiteNFCe'))"
                titulo="NFC-e"
                [exibirTituloNoAlerta]="false"
                descricaoAtivo="Emissão de NFC-e ativa neste emissor. Informe o último sequencial e a série utilizados."
                descricaoInativo="Emissão de NFC-e inativa. Este emissor não emite NFC-e."
                emptyStateTitulo="NFC-e desativada"
                emptyStateDescricao="Ative a emissão de NFC-e no cartão acima para informar o último sequencial e a série."
                (ativacaoChange)="onToggleEmiteNFCe()">
            </app-ativacao-section-card>

            @if (model.get('emiteNFCe')?.value) {
            <div class="section-container">
                <div class="section-title">
                    <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                    <span>NFC-e</span>
                </div>

                <div class="row g-3">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Último sequencial</mat-label>
                            <input matInput formControlName="ultimoSequencialNFCe" type="text"
                                maxlength="8" inputmode="numeric" pattern="[0-9]*"
                                (input)="onSequencialInput('ultimoSequencialNFCe', $any($event.target).value)">
                            @if (model.get('ultimoSequencialNFCe')?.invalid) {
                            <mat-error>Informe o sequencial da NFC-e</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Série</mat-label>
                            <input matInput formControlName="serieNFCe" type="text"
                                maxlength="3" inputmode="numeric" pattern="[0-9]*"
                                (input)="onSerieInput('serieNFCe', $any($event.target).value)">
                            @if (model.get('serieNFCe')?.invalid) {
                            <mat-error>Informe a série da NFC-e</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </div>
            }

            <app-ativacao-section-card
                [control]="$any(model.get('emiteNFe'))"
                titulo="NF-e"
                [exibirTituloNoAlerta]="false"
                descricaoAtivo="Emissão de NF-e ativa neste emissor. Informe o último sequencial e a série utilizados."
                descricaoInativo="Emissão de NF-e inativa. Este emissor não emite NF-e."
                emptyStateTitulo="NF-e desativada"
                emptyStateDescricao="Ative a emissão de NF-e no cartão acima para informar o último sequencial e a série."
                (ativacaoChange)="onToggleEmiteNFe()">
            </app-ativacao-section-card>

            @if (model.get('emiteNFe')?.value) {
            <div class="section-container">
                <div class="section-title">
                    <mat-icon class="material-symbols-outlined">description</mat-icon>
                    <span>NF-e</span>
                </div>

                <div class="row g-3">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Último sequencial</mat-label>
                            <input matInput formControlName="ultimoSequencialNFe" type="text"
                                maxlength="8" inputmode="numeric" pattern="[0-9]*"
                                (input)="onSequencialInput('ultimoSequencialNFe', $any($event.target).value)">
                            @if (model.get('ultimoSequencialNFe')?.invalid) {
                            <mat-error>Informe o sequencial da NF-e</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Série</mat-label>
                            <input matInput formControlName="serieNFe" type="text"
                                maxlength="3" inputmode="numeric" pattern="[0-9]*"
                                (input)="onSerieInput('serieNFe', $any($event.target).value)">
                            @if (model.get('serieNFe')?.invalid) {
                            <mat-error>Informe a série da NF-e</mat-error>
                            }
                            @if (isSerieNFeComNumeracao) {
                            <mat-hint>A série já tem numeração e não pode ser alterada. Para usar outra série, cadastre outro emissor.</mat-hint>
                            }
                        </mat-form-field>
                    </div>

                    <div class="toggle-content col-12">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="isPadraoNFe"
                            [matTooltip]="motivoPadraoIndisponivel ?? ''" [matTooltipDisabled]="!motivoPadraoIndisponivel">
                            Padrão para NF-e
                        </mat-slide-toggle>
                        <span class="info-text">
                            {{ motivoPadraoIndisponivel ?? 'Usado quando a natureza de operação não informa um emissor. Apenas um emissor por empresa pode ser o padrão.' }}
                        </span>
                    </div>
                </div>
            </div>
            }
        </form>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="_isLoading" (cancelar)="cancelar()" (salvar)="submit()"></app-footer-action>
